import { object, string } from 'yup';
import { FormValue } from '../_utils/state';

export type ContactKey = keyof ContactState;

export type ContactState = {
    name: FormValue;
    email: FormValue;
    details: FormValue;
}

export const INITIAL_STATE: ContactState = {
    name: { value: '', errors: [] },
    email: { value: '', errors: [] },
    details: { value: '', errors: [] }
}

export const nameSchema = string().required('お名前は必須です');
export const emailSchema = string().email('不正なメールアドレスです').required('メールアドレスは必須です');
export const detailsSchema = string().required('お問い合わせ内容は必須です');

export const schema = object({
    name: nameSchema,
    email: emailSchema,
    details: detailsSchema
});
